import { dataPreload, getCachedHtml } from "//chromeindustries.com/cdn/shop/t/276/assets/static.theme.js?v=62160826717710942761753382476";
class InfiniteScrollLoader extends HTMLElement {
    constructor() {
      super();
      this.currentPage = +this.dataset.currentPage;
      this.totalPages = +this.dataset.totalPages;
      this.isLoading = false;
      this.hasPreloaded = false;
      
      this.init();
    }
    
    init() {
      const button = this.querySelector('button');
      if (!button) return;

      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !this.hasPreloaded && !this.isLoading) {
          this.preload();
        }
      }, { rootMargin: '50px' }).observe(button);
      
      button.onclick = () => this.loadMore();
    }
    
    preload() {
      if (this.currentPage >= this.totalPages) return;
      this.hasPreloaded = true;
      dataPreload(`${this.dataset.collectionUrl}?page=${this.currentPage + 1}&section_id=${this.dataset.sectionId}`, true);
    }
    
    async loadMore() {
      if (this.isLoading || this.currentPage >= this.totalPages) return;
      
      this.isLoading = true;
      const button = this.querySelector('button');
      const originalText = button.textContent;
      
      button.textContent = 'Loading...';
      button.disabled = true;
      
      try {
        let html = getCachedHtml(`${this.dataset.collectionUrl}?page=${this.currentPage + 1}&section_id=${this.dataset.sectionId}`);
        if (!html) {
          html = await fetch(`${this.dataset.collectionUrl}?page=${this.currentPage + 1}&section_id=${this.dataset.sectionId}`).then(r => r.text());
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newProducts = doc.querySelector('product-list').children;
        
        const container = document.querySelector('product-list');
        Array.from(newProducts).forEach((product, i) => {
            product.style.opacity = '0';
            product.style.willChange = 'opacity, transform';
            container.appendChild(product);
            product.animate([
                { opacity: 0, transform: 'translateY(20px)' },
                { opacity: 1, transform: 'translateY(0)' }
            ], {
                duration: 300,
                delay: i * 50,
                fill: 'forwards',
                easing: 'ease'
            });
            setTimeout(() => {
                product.style.willChange = 'auto';
            }, 300 + (i * 50));
        });


        this.hasPreloaded = false;
        this.currentPage++;
        if (this.currentPage >= this.totalPages) {
          this.remove();
        } else {
          button.textContent = originalText;
          button.disabled = false;
        }
      } catch (error) {
        console.error('Load failed:', error);
        button.textContent = originalText;
        button.disabled = false;
      }
      
      this.isLoading = false;
    }

  }
  
  customElements.define('infinite-scroll-loader', InfiniteScrollLoader);